// extracted by mini-css-extract-plugin
export var quillEditor = "_hr-1";
export var variable = "_hr-0";